import { atom } from "recoil"

export const shareLinksModalAtom = atom({
  key: "shareLinksModalAtom",
  default: false
})
